import { NodeTemplatePart } from './node-template-part.js';
export class InnerTemplatePart extends NodeTemplatePart {
    constructor(template) {
        var _a;
        super(template, (_a = template.getAttribute('expression')) !== null && _a !== void 0 ? _a : '');
        this.template = template;
    }
    get directive() {
        var _a;
        return (_a = this.template.getAttribute('directive')) !== null && _a !== void 0 ? _a : '';
    }
}
//# sourceMappingURL=inner-template-part.js.map